import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        neutral: "border-[hsl(var(--ss-neutral)/0.35)] text-[hsl(var(--ss-neutral))] bg-[hsl(var(--ss-neutral)/0.1)]",
        success: "border-[hsl(var(--ss-success)/0.35)] text-[hsl(var(--ss-success))] bg-[var(--ss-success-bg)]",
        warning: "border-[hsl(var(--ss-warning)/0.35)] text-[hsl(var(--ss-warning))] bg-[var(--ss-warning-bg)]",
        danger: "border-[hsl(var(--ss-danger)/0.35)] text-[hsl(var(--ss-danger))] bg-[var(--ss-danger-bg)]",
        info: "border-[hsl(var(--ss-info)/0.35)] text-[hsl(var(--ss-info))] bg-[var(--ss-info-bg)]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(({ className, variant, ...props }, ref) => {
  return <div ref={ref} className={cn(badgeVariants({ variant }), className)} {...props} />;
});
Badge.displayName = "Badge";

export { Badge, badgeVariants };
